import type { ReactNode } from "react";
import { AudioWaveform } from "lucide-react";
import { cn } from "@/lib/utils";

export const IconWithAccessibilityBadge = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <span
      className={cn("relative inline-block shrink-0", className)}
      aria-hidden
    >
      {children}
      <span
        className={cn(
          `
            absolute -right-2 -bottom-2 flex size-3.5 items-center
            justify-center rounded-full
          `,
          "border border-transparent bg-white",
          `
            transition-colors
            [&_svg]:size-3!
          `,
          `
            group-hover:bg-accent
            group-hover:[&_svg]:text-accent-foreground
          `,
        )}
      >
        <AudioWaveform />
      </span>
    </span>
  );
};
